import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/commonimg/blog2.jpg";
import bannerImage1 from "../../Images/commonimg/blog1.jpg";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";
import axios from "axios";
import { Link } from "react-router-dom";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 10;

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(
          "https://isbmuniversity.edu.in/admin-portal/blogsApi",
        );

        console.log("Blogs API response:", response.data);

        const data = response.data?.data || response.data;

        if (Array.isArray(data)) {
          // Sort newest blogs first using created_at
          const sortedBlogs = [...data].sort((a, b) => {
            return (
              new Date(b.created_at || 0).getTime() -
              new Date(a.created_at || 0).getTime()
            );
          });
          setBlogs(sortedBlogs);
        } else {
          setBlogs([]);
        }
      } catch (err) {
        console.error("Error fetching blogs:", err);
        setError("Failed to load blogs.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  // Total pages
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  // Get blogs for current page
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;

  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  // Change page
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);

    // Scroll back to blog section
    window.scrollTo({
      top: 400,
      behavior: "smooth",
    });
  };

  return (
    <>
      <title>
        ISBM University Blog | Insights on Education, Careers & Campus Life
      </title>

      <meta
        name="description"
        content="Explore the ISBM University Blog for expert articles on education trends, career advice, student experiences, and more. Stay informed and inspired."
      />

      <Topnav />

      {/* Banner */}
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Blog List</h1>

              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a
                    href="/"
                    style={{
                      color: "#fff",
                      textDecoration: "none",
                    }}
                  >
                    Home
                  </a>
                </li>

                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Blog List
                </li>

                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Cards */}
      <section className="container-xxl my-4">
        {loading && <p className="text-center">Loading blogs...</p>}

        {error && <p className="text-center text-danger">{error}</p>}

        {!loading && !blogs.length && (
          <p className="text-center">No blogs available.</p>
        )}

        {!loading && blogs.length > 0 && (
          <>
            <div className="row g-4 mt-5 mb-5">
              {currentBlogs.map((blog, index) => (
                <div className="col-md-6" key={index}>
                  <div className="card shadow border-1 rounded-5 overflow-hidden h-100">
                    <div className="row g-0">
                      {/* Blog Thumbnail */}
                      <div className="col-6">
                        <Link
                          to={`/blog/${blog.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={
                              blog.banner && blog.banner.trim() !== ""
                                ? `https://isbmuniversity.edu.in/admin-server/public/uploads/blogs/${blog.banner}`
                                : bannerImage1
                            }
                            alt={blog.title || "Blog Thumbnail"}
                            className="card-img-top"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = bannerImage1;
                            }}
                          />
                        </Link>
                      </div>

                      {/* Blog Content */}
                      <div className="col-6 d-flex flex-column justify-content-between p-3">
                        <div>
                          {/* Meta */}
                          <div className="d-flex mb-2 text-muted small mb-3">
                            <div className="me-3 d-flex align-items-center">
                              <i
                                className="ti ti-calendar me-1 text-black"
                                style={{
                                  fontSize: "20px",
                                }}
                              ></i>

                              {blog.created_at
                                ? new Date(
                                    blog.created_at || blog.date_created,
                                  ).toLocaleDateString("en-GB")
                                : "N/A"}
                            </div>

                            <div className="d-flex align-items-center">
                              <i
                                className="ti ti-user me-1 text-black"
                                style={{
                                  fontSize: "20px",
                                }}
                              ></i>

                              <span>
                                {blog.author || blog.user_id || "admin"}
                              </span>
                            </div>
                          </div>

                          {/* Title */}
                          <h5 className="card-title fw-bold">
                            <Link
                              to={`/blog/${blog.url}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-dark text-decoration-none"
                            >
                              {blog.title}
                            </Link>
                          </h5>
                        </div>

                        {/* Button */}
                        <div>
                          <Link
                            to={`/blog/${blog.url}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-blue mt-3"
                          >
                            Read More{" "}
                            <i className="rt rt-arrow-right-regular ms-1"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <nav
                aria-label="Blog pagination"
                className="d-flex justify-content-center mb-5"
              >
                <ul className="pagination">
                  {/* Previous */}
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      style={{ color: "black" }}
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                  </li>

                  {/* Page Numbers */}
                  {Array.from(
                    { length: totalPages },
                    (_, index) => index + 1,
                  ).map((page) => (
                    <li
                      key={page}
                      className={`page-item ${
                        currentPage === page ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page)}
                        style={{
                          backgroundColor:
                            currentPage === page
                              ? "var(--primary-color)"
                              : "transparent",
                          color:
                            currentPage === page
                              ? "#fff"
                              : "var(--primary-color)",
                          borderColor: "var(--primary-color)",
                        }}
                      >
                        {page}
                      </button>
                    </li>
                  ))}

                  {/* Next */}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      style={{ color: "black" }}
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </>
        )}
      </section>

      <Footer />
    </>
  );
};

export default BlogList;
